export const examples = {
    // Conditionals
    "first": {
        title: "First Conditional - Ejemplos",
        content: [
            "If it rains tomorrow, we will cancel the picnic.",
            "She will pass the exam if she studies hard.",
            "If you leave now, you'll catch the train.",
            "I will call you if I need help.",
            "If he is late, we won't wait for him."
        ]
    },
    "second": {
        title: "Second Conditional - Ejemplos",
        content: [
            "If I were rich, I would travel the world.",
            "She would drive to work if she had a car.",
            "If they were here, they would help us.",
            "I would buy a house if I had enough money.",
            "If she spoke English, she would get the job."
        ]
    },
    "third": {
        title: "Third Conditional - Ejemplos",
        content: [
            "If I had studied harder, I would have passed the exam.",
            "She would have come if she had known about the party.",
            "If they had left earlier, they wouldn't have missed the train.",
            "I would have called you if I had had your number.",
            "If it hadn't rained, we would have gone to the beach."
        ]
    },
    "comparative": {
        title: "Comparatives - Ejemplos",
        content: [
            "This book is more interesting than that one.",
            "She is taller than her sister.",
            "My car is faster than yours.",
            "English is easier than Chinese.",
            "Today is hotter than yesterday."
        ]
    },
    "superlative": {
        title: "Superlatives - Ejemplos",
        content: [
            "She is the most intelligent student in the class.",
            "This is the happiest day of my life.",
            "Mount Everest is the highest mountain in the world.",
            "He is the funniest person I know.",
            "This is the worst movie I've ever seen."
        ]
    },

    // WH-Words (NUEVA SECCIÓN AÑADIDA)
    "what": {
        title: "What (Object/Action) - Ejemplos",
        content: [
            "What is this?",
            "What are you doing?",
            "What time is it?",
            "What is your favorite color?"
        ]
    },
    "who": {
        title: "Who (Person) - Ejemplos",
        content: [
            "Who is the new teacher?",
            "Who helped you with your homework?",
            "Who is calling at this hour?",
            "Who do you think will win?"
        ]
    },
    "where": {
        title: "Where (Place) - Ejemplos",
        content: [
            "Where do you work?",
            "Where did you go on vacation?",
            "Where is the nearest hospital?",
            "Where are my keys?"
        ]
    },
    "when": {
        title: "When (Time) - Ejemplos",
        content: [
            "When do you start work?",
            "When did you arrive?",
            "When is your birthday?",
            "When will the meeting start?"
        ]
    },
    "why": {
        title: "Why (Reason) - Ejemplos",
        content: [
            "Why did you come late?",
            "Why are you sad?",
            "Why is the sky blue?",
            "Why didn't you call me?"
        ]
    },
    "how": {
        title: "How (Manner/Frequency) - Ejemplos",
        content: [
            "How do you spell that?",
            "How often do you exercise?",
            "How was your trip?",
            "How can I help you?"
        ]
    },
    "which": {
        title: "Which (Choice) - Ejemplos",
        content: [
            "Which car do you prefer, the red one or the blue one?",
            "Which of these books have you read?",
            "Which path should we take?",
            "Which color looks better on me?"
        ]
    },
    "whose": {
        title: "Whose (Possession) - Ejemplos",
        content: [
            "Whose car is this?",
            "Whose book are you reading?",
            "Whose keys are on the table?",
            "Whose idea was it to come here?"
        ]
    },

    // Computer Vocabulary (NUEVA SECCIÓN AÑADIDA)
    "hardware": {
        title: "Hardware Components - Ejemplos",
        content: [
            "The CPU is the brain of the computer.",
            "I need a new hard disk with more storage.",
            "My mouse is not working properly.",
            "The monitor has a very sharp image."
        ]
    },
    "software": {
        title: "Software Types - Ejemplos",
        content: [
            "Windows is a popular operating system.",
            "You must install an antivirus to protect your PC.",
            "Microsoft Word is an application software for writing documents."
        ]
    },
    "fileManagement": {
        title: "File Management Verbs - Ejemplos",
        content: [
            "You need to save your work frequently.",
            "Don't forget to upload the file to the cloud.",
            "I will download the movie later.",
            "Please rename this document."
        ]
    },
    "internet": {
        title: "Internet Expressions - Ejemplos",
        content: [
            "I can't connect to the internet.",
            "I like to surf the web in my free time.",
            "Did you send the email I asked for?",
            "Let's search for it on Google."
        ]
    },
    "formatting": {
        title: "Document Formatting - Ejemplos",
        content: [
            "Change the font to Arial, size 12.",
            "Use bold to highlight the important words.",
            "You can copy this text and paste it in the email.",
            "Please underline the title."
        ]
    },

    // Tag Questions
    "positive-tag": {
        title: "Tag Questions: Positive Statement + Negative Tag",
        content: [
            "You are a teacher, aren't you?",
            "She speaks French, doesn't she?",
            "They have finished, haven't they?",
            "He can drive, can't he?",
            "You will help me, won't you?"
        ]
    },
    "negative-tag": {
        title: "Tag Questions: Negative Statement + Positive Tag",
        content: [
            "You're not from here, are you?",
            "She doesn't like coffee, does she?",
            "They haven't arrived, have they?",
            "He can't swim, can he?",
            "You won't be late, will you?"
        ]
    },
    "countable": {
        title: "Countable Nouns - Sustantivos Contables",
        content: [
            "I have three books on my desk.",
            "She bought two apples and five oranges.",
            "There are many students in the classroom.",
            "How many cars do you have?",
            "We need a few chairs for the meeting."
        ]
    },
    "uncountable": {
        title: "Uncountable Nouns - Sustantivos Incontables",
        content: [
            "I need some water, please.",
            "There isn't much milk left.",
            "She gave me good advice.",
            "How much money do you need?",
            "We have a little time before the meeting."
        ]
    },
    "some-any-no": {
        title: "Some/Any/No Rules",
        content: [
            "I have some cookies for you.",
            "Do you have any questions?",
            "There are no problems with the plan.",
            "She doesn't have any friends here.",
            "There's no milk in the fridge."
        ]
    },

    // Verb Tenses
    "simple-present": {
        title: "Simple Present - Presente Simple",
        content: [
            "I work in an office downtown.",
            "She speaks three languages fluently.",
            "The sun rises in the east.",
            "We eat breakfast at 7 AM.",
            "They live in a beautiful house."
        ]
    },
    "present-continuous": {
        title: "Present Continuous - Presente Continuo",
        content: [
            "I am working on a new project.",
            "She is reading a fascinating book.",
            "We are planning our vacation.",
            "They are cooking dinner together.",
            "The children are playing in the garden."
        ]
    },
    "simple-past": {
        title: "Simple Past - Pasado Simple",
        content: [
            "I visited my grandmother last weekend.",
            "She studied medicine at university.",
            "We traveled to Europe last summer.",
            "They bought a new car yesterday.",
            "He finished his homework early."
        ]
    },
    "past-continuous": {
        title: "Past Continuous - Pasado Continuo",
        content: [
            "I was sleeping when the phone rang.",
            "She was cooking when the guests arrived.",
            "We were watching TV all evening.",
            "They were walking in the park.",
            "It was raining heavily last night."
        ]
    },
    "present-perfect": {
        title: "Present Perfect - Presente Perfecto",
        content: [
            "I have lived here for five years.",
            "She has visited many countries.",
            "We have finished our homework.",
            "They have known each other since childhood.",
            "He has worked here since 2020."
        ]
    },
    "past-perfect": {
        title: "Past Perfect - Pasado Perfecto",
        content: [
            "I had already eaten when she arrived.",
            "She had studied English before moving to America.",
            "We had finished dinner by 8 PM.",
            "They had left before the rain started.",
            "He had never seen snow before that day."
        ]
    },
    "future-simple": {
        title: "Future Simple - Futuro Simple",
        content: [
            "I will call you tomorrow.",
            "She will graduate next year.",
            "We will travel to Japan in summer.",
            "They will move to a new house.",
            "The weather will be sunny today."
        ]
    },
    "going-to-future": {
        title: "Going to Future",
        content: [
            "I'm going to study tonight.",
            "She's going to travel next month.",
            "We're going to buy a new house.",
            "They're going to start tomorrow.",
            "It's going to rain this afternoon."
        ]
    },

    // Modal Verbs
    "can": {
        title: "CAN - Ability & Permission",
        content: [
            "I can speak three languages.",
            "Can you help me with this?",
            "She can drive very well.",
            "Can I use your phone?",
            "We can meet tomorrow if you want."
        ]
    },
    "could": {
        title: "COULD - Past Ability & Polite Request",
        content: [
            "I could swim when I was five.",
            "Could you please close the window?",
            "She could play piano very well.",
            "Could I borrow your book?",
            "We could go to the movies tonight."
        ]
    },
    "must": {
        title: "MUST - Strong Obligation",
        content: [
            "You must wear a seatbelt.",
            "Students must complete their homework.",
            "We must leave now or we'll be late.",
            "You must be tired after the long trip.",
            "This must be the right address."
        ]
    },
    "should": {
        title: "SHOULD - Advice & Recommendation",
        content: [
            "You should eat more vegetables.",
            "We should leave early to avoid traffic.",
            "She should see a doctor about that cough.",
            "You should study harder for the exam.",
            "We should call them before visiting."
        ]
    },
    "may": {
        title: "MAY - Permission & Possibility",
        content: [
            "May I sit here?",
            "It may rain this afternoon.",
            "You may use my computer.",
            "She may be at home now.",
            "May I have your attention, please?"
        ]
    },
    "might": {
        title: "MIGHT - Possibility",
        content: [
            "I might go to the party tonight.",
            "She might be sick today.",
            "It might snow tomorrow.",
            "We might need more time.",
            "He might call you later."
        ]
    },

    // Modal Verbs Past
    "must-have": {
        title: "MUST HAVE - Deducciones del Pasado (99% Seguro)",
        content: [
            "He must have forgotten the meeting. (Debe haber olvidado la reunión)",
            "She must have been very tired. (Debe haber estado muy cansada)",
            "They must have left early. (Deben haberse ido temprano)",
            "It must have been expensive. (Debe haber sido caro)",
            "You must have studied hard. (Debes haber estudiado mucho)"
        ]
    },
    "cant-have": {
        title: "CAN'T HAVE - Imposibilidad en el Pasado",
        content: [
            "She can't have said that. (No puede haber dicho eso)",
            "He can't have finished already. (No puede haber terminado ya)",
            "They can't have known about it. (No pueden haber sabido sobre eso)",
            "It can't have been that difficult. (No puede haber sido tan difícil)",
            "You can't have seen him yesterday. (No puedes haberlo visto ayer)"
        ]
    },
    "could-have": {
        title: "COULD HAVE - Posibilidad Pasada No Realizada",
        content: [
            "You could have called me. (Podrías haberme llamado)",
            "She could have been a doctor. (Podría haber sido doctora)",
            "We could have won the game. (Podríamos haber ganado el juego)",
            "He could have helped us. (Podría habernos ayudado)",
            "They could have arrived earlier. (Podrían haber llegado más temprano)"
        ]
    },
    "should-have": {
        title: "SHOULD HAVE - Consejos sobre el Pasado",
        content: [
            "I should have studied harder. (Debería haber estudiado más)",
            "You should have told me. (Deberías habérmelo dicho)",
            "She should have taken the job. (Debería haber aceptado el trabajo)",
            "We should have left earlier. (Deberíamos haber salido más temprano)",
            "They should have been more careful. (Deberían haber sido más cuidadosos)"
        ]
    },

    // Phrasal Verbs
    "look-up": {
        title: "LOOK UP - Buscar información",
        content: [
            "I need to look up this word in the dictionary.",
            "Can you look up the restaurant's phone number?",
            "She looked up the recipe online.",
            "Look up the train schedule before leaving.",
            "He looked up his old friend's address."
        ]
    },
    "turn-on-off": {
        title: "TURN ON/OFF - Encender/Apagar",
        content: [
            "Please turn on the lights.",
            "Don't forget to turn off the TV.",
            "Turn on the heater, it's cold.",
            "I always turn off my phone at night.",
            "Can you turn on the air conditioning?"
        ]
    },
    "get-up": {
        title: "GET UP - Levantarse",
        content: [
            "I get up at 7 AM every day.",
            "She got up early to catch the flight.",
            "Get up! You're going to be late.",
            "He couldn't get up this morning.",
            "What time did you get up today?"
        ]
    },
    "give-up": {
        title: "GIVE UP - Rendirse/Dejar",
        content: [
            "Don't give up on your dreams.",
            "I gave up smoking last year.",
            "She gave up trying to fix the car.",
            "Never give up, keep trying!",
            "He gave up his job to travel."
        ]
    },
    "put-on-off": {
        title: "PUT ON/OFF - Ponerse/Quitarse",
        content: [
            "Put on your coat, it's cold outside.",
            "I need to put off this meeting.",
            "She put on her best dress.",
            "Put on your seatbelt for safety.",
            "The event was put off until next week."
        ]
    },
    "take-off": {
        title: "TAKE OFF - Quitarse/Despegar",
        content: [
            "Take off your shoes before entering.",
            "The plane will take off in 10 minutes.",
            "Take off your hat indoors.",
            "Her career really took off last year.",
            "Take off that wet jacket."
        ]
    },
    "pick-up": {
        title: "PICK UP - Recoger/Aprender",
        content: [
            "Can you pick up some milk on your way home?",
            "I'll pick you up at 8 PM.",
            "She picked up Spanish very quickly.",
            "Pick up your clothes from the floor.",
            "He picked up the phone immediately."
        ]
    },
    "drop-off": {
        title: "DROP OFF - Dejar/Llevar",
        content: [
            "I'll drop you off at the station.",
            "Drop off these books at the library.",
            "Can you drop off my dry cleaning?",
            "She dropped the kids off at school.",
            "Drop off the package at the office."
        ]
    },
    "find-out": {
        title: "FIND OUT - Descubrir/Averiguar",
        content: [
            "I need to find out what time the store closes.",
            "She found out the truth about the accident.",
            "Find out who's responsible for this mess.",
            "We found out about the party too late.",
            "I'll find out the answer for you."
        ]
    },
    "work-out": {
        title: "WORK OUT - Ejercitarse/Resolver",
        content: [
            "I work out at the gym every morning.",
            "We need to work out this problem together.",
            "She works out three times a week.",
            "Everything will work out fine.",
            "Let's work out the details later."
        ]
    },
    "come-back": {
        title: "COME BACK - Regresar/Volver",
        content: [
            "What time will you come back?",
            "She came back from vacation yesterday.",
            "Come back soon, we'll miss you!",
            "The fashion from the 80s is coming back.",
            "He came back stronger than ever."
        ]
    },
    "go-out": {
        title: "GO OUT - Salir",
        content: [
            "Let's go out for dinner tonight.",
            "She goes out with friends every Friday.",
            "The fire went out during the night.",
            "Are you going out this weekend?",
            "They've been going out for two years."
        ]
    },
    "break-down": {
        title: "BREAK DOWN - Descomponerse/Colapsar",
        content: [
            "My car broke down on the highway.",
            "She broke down and started crying.",
            "The machine breaks down frequently.",
            "Let's break down this problem step by step.",
            "The negotiations broke down yesterday."
        ]
    },
    "call-back": {
        title: "CALL BACK - Devolver la llamada",
        content: [
            "I'll call you back in an hour.",
            "She called back immediately.",
            "Can you call me back later?",
            "The doctor will call back with results.",
            "He never calls back when I leave messages."
        ]
    },
    "fill-out": {
        title: "FILL OUT - Rellenar/Completar",
        content: [
            "Please fill out this application form.",
            "I need to fill out my tax return.",
            "Fill out all the required fields.",
            "She filled out the survey online.",
            "Don't forget to fill out the address section."
        ]
    },
    "run-out": {
        title: "RUN OUT - Quedarse sin/Agotarse",
        content: [
            "We've run out of milk.",
            "Don't let your phone battery run out.",
            "Time is running out for the project.",
            "The store ran out of bread.",
            "I've run out of patience with this situation."
        ]
    },
    "show-up": {
        title: "SHOW UP - Aparecer/Presentarse",
        content: [
            "He didn't show up for the meeting.",
            "I hope the weather shows up nice tomorrow.",
            "She always shows up on time.",
            "The problem showed up during testing.",
            "Will you show up to the party?"
        ]
    },
    "hang-out": {
        title: "HANG OUT - Pasar el rato",
        content: [
            "Let's hang out at the mall.",
            "I like to hang out with my friends.",
            "We hung out at the beach all day.",
            "Where do you usually hang out?",
            "They hang out at the coffee shop."
        ]
    },
    "set-up": {
        title: "SET UP - Configurar/Establecer",
        content: [
            "I need to set up my new computer.",
            "Let's set up a meeting for next week.",
            "She set up her own business.",
            "Can you help me set up the projector?",
            "They set up camp near the lake."
        ]
    },
    "clean-up": {
        title: "CLEAN UP - Limpiar",
        content: [
            "We need to clean up this mess.",
            "Clean up your room before dinner.",
            "The volunteers helped clean up the park.",
            "I'll clean up the kitchen after cooking.",
            "It took hours to clean up after the party."
        ]
    },
    "catch-up": {
        title: "CATCH UP - Ponerse al día",
        content: [
            "I need to catch up on my reading.",
            "Let's catch up over coffee sometime.",
            "She's trying to catch up with her classmates.",
            "We caught up on all the latest news.",
            "It took me weeks to catch up after being sick."
        ]
    },
    "back-up": {
        title: "BACK UP - Respaldar/Retroceder",
        content: [
            "Don't forget to back up your files.",
            "Can you back up a little bit?",
            "I always back up my photos to the cloud.",
            "The traffic is backing up on the highway.",
            "Please back up your claims with evidence."
        ]
    },
    "cut-down": {
        title: "CUT DOWN - Reducir/Talar",
        content: [
            "I need to cut down on sugar.",
            "They cut down the old tree.",
            "Cut down your expenses this month.",
            "She's cutting down on coffee.",
            "The city cut down several trees for construction."
        ]
    },
    "bring-up": {
        title: "BRING UP - Mencionar/Criar",
        content: [
            "Don't bring up that topic again.",
            "She was brought up by her grandparents.",
            "I'll bring up your suggestion at the meeting.",
            "They brought up their children well.",
            "He brought up an interesting point."
        ]
    },
    "check-out": {
        title: "CHECK OUT - Revisar/Irse del hotel",
        content: [
            "Check out this amazing video!",
            "We need to check out of the hotel by noon.",
            "I'll check out these books from the library.",
            "Check out the new restaurant downtown.",
            "She checked out early from the conference."
        ]
    },

    // Places
    "places_city": {
        title: "Places in the City",
        content: [
            "Let's go to the movies and watch a film.",
            "The park is perfect for a morning walk.",
            "We visited the museum last weekend.",
            "The zoo has many exotic animals.",
            "I love eating at that restaurant."
        ]
    },
    "places_outside": {
        title: "Places Outside the City",
        content: [
            "We went to the beach and had a picnic.",
            "The mountains offer amazing hiking trails.",
            "The botanical gardens are beautiful in spring.",
            "Let's visit the national park this summer.",
            "The historic site teaches us about the past."
        ]
    },
    "city_places_list": {
        title: "City Places List",
        content: [
            "The park is great for children to play.",
            "I love going to the movies on weekends.",
            "The zoo has many interesting animals.",
            "Let's eat at that new restaurant.",
            "The museum has an amazing art collection."
        ]
    },
    "city_activities": {
        title: "City Activities",
        content: [
            "Watching movies is my favorite activity.",
            "We're eating popcorn and nachos.",
            "I love eating delicious food at restaurants.",
            "Dancing at the club is so much fun.",
            "Riding the roller coaster was exciting."
        ]
    },
    "outside_places": {
        title: "Outside City Places",
        content: [
            "The beach has beautiful white sand.",
            "The mountains offer breathtaking views.",
            "The botanical gardens have rare flowers.",
            "The national park protects wildlife.",
            "We visited a historic site yesterday."
        ]
    },
    "outdoor_activities": {
        title: "Outdoor Activities",
        content: [
            "We had a picnic by the lake.",
            "Roller blading in the park is fun.",
            "I enjoy walking my pets daily.",
            "Sunbathing at the beach is relaxing.",
            "Surfing requires skill and balance."
        ]
    },

    // Numbers and Dates
    "months_year": {
        title: "Months of the Year",
        content: [
            "January has 31 days.",
            "February is the shortest month.",
            "March brings the beginning of spring.",
            "April has beautiful flowers blooming.",
            "December is when we celebrate Christmas."
        ]
    },
    "cardinal_numbers": {
        title: "Cardinal Numbers 1-31",
        content: [
            "I have twenty-one books.",
            "There are thirty days in April.",
            "She bought fifteen apples.",
            "The building has twenty-four floors.",
            "We need thirty-one chairs."
        ]
    },
    "ordinal_numbers": {
        title: "Ordinal Numbers 1st-31st",
        content: [
            "Today is the twenty-first of March.",
            "This is my third attempt.",
            "She finished in first place.",
            "It's the fifteenth of the month.",
            "The meeting is on the tenth floor."
        ]
    },
    "date_prepositions": {
        title: "Date Prepositions",
        content: [
            "I was born in 1995.",
            "The meeting is on July 4th.",
            "We start work on Monday.",
            "In winter, it gets dark early.",
            "On weekends, I like to relax."
        ]
    },
    "date_reading": {
        title: "Reading Dates",
        content: [
            "July 4th is the fourth of July.",
            "Independence Day is July fourth.",
            "Christmas is December 25th.",
            "New Year's is January first.",
            "Halloween is October thirty-first."
        ]
    },

    // Additions to Remark
    "too_so_positive": {
        title: "Too / So (Positive Agreement)",
        content: [
            "I love music and John does too.",
            "So does John.",
            "She likes pizza and I do too.",
            "So do I.",
            "They went to the party and we did too."
        ]
    },
    "either_neither_negative": {
        title: "Either / Neither (Negative Agreement)",
        content: [
            "I don't like salsa and Maria doesn't either.",
            "Neither does Maria.",
            "He can't swim and I can't either.",
            "Neither can I.",
            "They didn't come and we didn't either."
        ]
    },
    "either_or": {
        title: "Either...or",
        content: [
            "We can eat either meat or chicken.",
            "Either you come or I go.",
            "Choose either the red or blue shirt.",
            "Either call me or send a text.",
            "We can go either today or tomorrow."
        ]
    },
    "neither_nor": {
        title: "Neither...nor",
        content: [
            "There are neither taxis nor buses at this time.",
            "Neither John nor Mary came to the party.",
            "I like neither coffee nor tea.",
            "Neither the book nor the movie was good.",
            "She has neither time nor money."
        ]
    },
    "responses_agreement": {
        title: "Agreement Responses",
        content: [
            "A: I love pizza. B: So do I!",
            "A: I don't like rain. B: Neither do I.",
            "A: She's very smart. B: Yes, she is.",
            "A: I can't sing. B: Me neither.",
            "A: I'm hungry. B: Me too!"
        ]
    },

    // Clothing
    "head_accessories": {
        title: "Head Accessories - Accesorios para la Cabeza",
        content: [
            "She's wearing a beautiful hat today.",
            "My cap protects me from the sun.",
            "The baseball cap is my favorite.",
            "I need sunglasses for the beach.",
            "His headband keeps sweat away."
        ]
    },
    "jewelry_accessories": {
        title: "Jewelry & Accessories - Joyas y Accesorios",
        content: [
            "Her diamond ring is stunning.",
            "I lost my favorite earrings.",
            "The gold necklace was a gift.",
            "He wears a watch every day.",
            "The silver bracelet matches her outfit."
        ]
    },
    "upper_body_clothing": {
        title: "Upper Body Clothing - Ropa de Parte Superior",
        content: [
            "This shirt is very comfortable.",
            "I need a warm sweater for winter.",
            "Her blouse is perfect for work.",
            "The jacket looks great on you.",
            "His t-shirt has a funny design."
        ]
    },
    "lower_body_clothing": {
        title: "Lower Body Clothing - Ropa de Parte Inferior",
        content: [
            "These jeans are my favorite.",
            "Her dress is perfect for the party.",
            "I need new pants for work.",
            "The skirt matches her top.",
            "His shorts are perfect for summer."
        ]
    },
    "formal_clothing": {
        title: "Formal Clothing - Ropa Formal",
        content: [
            "He looks handsome in his suit.",
            "The wedding dress is beautiful.",
            "I need a tuxedo for the gala.",
            "Her evening gown is elegant.",
            "The business suit fits perfectly."
        ]
    },
    "footwear": {
        title: "Footwear - Calzado",
        content: [
            "These shoes are very comfortable.",
            "I need new boots for hiking.",
            "Her sneakers are perfect for running.",
            "The sandals are great for summer.",
            "His dress shoes shine brightly."
        ]
    },
    "underwear": {
        title: "Underwear - Ropa Interior",
        content: [
            "I need to buy new socks.",
            "Cotton underwear is more comfortable.",
            "She prefers sports bras for exercise.",
            "Thermal underwear keeps you warm.",
            "These socks have a fun pattern."
        ]
    },

    // Comparatives and Superlatives
    "short_adjectives": {
        title: "Short Adjectives (-er/-est)",
        content: [
            "John is taller than Mike.",
            "John is the tallest in class.",
            "This book is cheaper than that one.",
            "This is the cheapest option.",
            "She's older than her sister."
        ]
    },
    "long_adjectives": {
        title: "Long Adjectives (more/most)",
        content: [
            "This is more expensive than that.",
            "This is the most expensive item.",
            "She's more beautiful than her sister.",
            "This is the most beautiful place.",
            "The movie was more interesting."
        ]
    },
    "irregular_comparatives": {
        title: "Irregular Comparatives",
        content: [
            "This pizza is better than yesterday's.",
            "It's the best pizza ever.",
            "Today is worse than yesterday.",
            "This is the worst day ever.",
            "The store is farther than I thought."
        ]
    },
    "as_as_comparisons": {
        title: "As...as / Less...than",
        content: [
            "Cars aren't as fast as planes.",
            "Planes are less comfortable than cars.",
            "She's as tall as her brother.",
            "This book is as good as that one.",
            "Coffee is less healthy than tea."
        ]
    },
    "double_comparatives": {
        title: "Double Comparatives",
        content: [
            "The funnier the movie, the more I enjoy it.",
            "The harder you study, the better your grades.",
            "The more you practice, the easier it becomes.",
            "The older I get, the wiser I become.",
            "The faster you drive, the more dangerous it is."
        ]
    },
    "spelling_rules": {
        title: "Spelling Rules for Comparatives",
        content: [
            "big → bigger → biggest",
            "happy → happier → happiest",
            "nice → nicer → nicest",
            "hot → hotter → hottest",
            "easy → easier → easiest"
        ]
    },

    // Restaurant Menu
    "appetizers": {
        title: "Appetizers - Aperitivos",
        content: [
            "Let's order some appetizers first.",
            "The chicken wings are delicious.",
            "I love nachos as a starter.",
            "Mozzarella sticks are my favorite.",
            "The shrimp cocktail looks fresh."
        ]
    },
    "salads": {
        title: "Salads - Ensaladas",
        content: [
            "The Caesar salad is very popular.",
            "I'll have a Greek salad, please.",
            "Garden salads are healthy choices.",
            "The fruit salad is refreshing.",
            "This chef's salad has everything."
        ]
    },
    "entrees": {
        title: "Entrees - Platos Principales",
        content: [
            "The grilled chicken is perfectly cooked.",
            "I ordered the salmon for dinner.",
            "The pasta dish looks amazing.",
            "This steak is cooked to perfection.",
            "The vegetarian option is delicious."
        ]
    },
    "side_dishes": {
        title: "Side Dishes - Acompañamientos",
        content: [
            "The mashed potatoes are creamy.",
            "I'll have rice as a side dish.",
            "The steamed vegetables are healthy.",
            "French fries go well with burgers.",
            "The bread rolls are freshly baked."
        ]
    },
    "desserts": {
        title: "Desserts - Postres",
        content: [
            "The chocolate cake is heavenly.",
            "I can't resist the ice cream.",
            "The apple pie smells wonderful.",
            "This cheesecake is my weakness.",
            "The fruit tart looks beautiful."
        ]
    },
    "beverages": {
        title: "Beverages - Bebidas",
        content: [
            "I'll have a coffee, please.",
            "The orange juice is freshly squeezed.",
            "This tea is very relaxing.",
            "The soda is ice cold.",
            "I prefer water with my meal."
        ]
    },

    // Tag Questions Expanded
    "positive_negative_tags": {
        title: "Positive → Negative Tags",
        content: [
            "You are a member of this gym, aren't you?",
            "She speaks French, doesn't she?",
            "They have finished, haven't they?",
            "He can drive, can't he?",
            "You will help me, won't you?"
        ]
    },
    "negative_positive_tags": {
        title: "Negative → Positive Tags",
        content: [
            "You're not my girlfriend, are you?",
            "She doesn't like coffee, does she?",
            "They haven't arrived, have they?",
            "He can't swim, can he?",
            "You won't be late, will you?"
        ]
    },
    "reply_questions": {
        title: "Reply Questions",
        content: [
            "A: I have a fever. B: Do you?",
            "A: She's not coming. B: Isn't she?",
            "A: They left early. B: Did they?",
            "A: I can't find my keys. B: Can't you?",
            "A: We're going tomorrow. B: Are you?"
        ]
    },
    "tag_with_modals": {
        title: "Tags with Modal Verbs",
        content: [
            "You should come early, shouldn't you?",
            "She can drive, can't she?",
            "They must be tired, mustn't they?",
            "You could help me, couldn't you?",
            "We might go, mightn't we?"
        ]
    },
    "tag_with_perfect": {
        title: "Tags with Perfect Tenses",
        content: [
            "It has been down, hasn't it?",
            "You have finished, haven't you?",
            "She had left, hadn't she?",
            "They have been waiting, haven't they?",
            "You had seen it before, hadn't you?"
        ]
    },

    // Food Preparation
    "measurements": {
        title: "Cooking Measurements",
        content: [
            "Add two cups of flour.",
            "Use a teaspoon of salt.",
            "Pour one liter of milk.",
            "Add a tablespoon of sugar.",
            "Buy a dozen eggs."
        ]
    },
    "preparation_verbs": {
        title: "Food Preparation Verbs",
        content: [
            "Prepare the ingredients first.",
            "Cook the pasta for 10 minutes.",
            "Bake the cake at 350 degrees.",
            "Peel the potatoes carefully.",
            "Chop the vegetables into small pieces."
        ]
    },
    "recipe_sequence": {
        title: "Recipe Sequence Words",
        content: [
            "First, mix the ingredients.",
            "Second, add the milk slowly.",
            "Next, beat the eggs.",
            "Then, pour into the pan.",
            "Finally, bake for 30 minutes."
        ]
    },
    "fractions_cooking": {
        title: "Fractions in Cooking",
        content: [
            "Use half a cup of sugar.",
            "Add a quarter cup of butter.",
            "Mix one and a third cups of flour.",
            "Pour two thirds of the mixture.",
            "Use one fourth teaspoon of vanilla."
        ]
    },

    // Conditionals Expanded
    "first_conditional_real": {
        title: "First Conditional (Real/Possible)",
        content: [
            "If it rains tomorrow, we will stay home.",
            "If you study hard, you will pass the exam.",
            "If she comes early, we will start the meeting.",
            "If they don't hurry, they will miss the bus.",
            "If I save money, I will buy a new car."
        ]
    },
    "first_conditional_unless": {
        title: "First Conditional with Unless",
        content: [
            "Unless our team scores more goals, it won't win.",
            "Unless you study, you will fail the exam.",
            "Unless it rains, we will have the picnic.",
            "Unless she calls, I won't know the time.",
            "Unless they hurry, they will be late."
        ]
    },
    "second_conditional_unreal": {
        title: "Second Conditional (Unreal/Unlikely)",
        content: [
            "If I were rich, I would travel around the world.",
            "If she were here, she would help us.",
            "If I had a car, I would drive to work.",
            "If they were taller, they could play basketball.",
            "If it were sunny, we would go to the beach."
        ]
    },
    "second_conditional_advice": {
        title: "Second Conditional for Advice",
        content: [
            "If I were you, I would study harder.",
            "If I were in your position, I would quit.",
            "If I were you, I would accept the job.",
            "If I were you, I would call the doctor.",
            "If I were you, I would save more money."
        ]
    },
    "third_conditional_past": {
        title: "Third Conditional (Past Regrets)",
        content: [
            "If I had studied harder, I would have passed.",
            "If she had left earlier, she wouldn't have been late.",
            "If they had invited me, I would have come.",
            "If we had known, we would have helped.",
            "If it hadn't rained, we would have had the picnic."
        ]
    },
    "mixed_conditionals": {
        title: "Mixed Conditionals",
        content: [
            "If I had taken that job, I would be rich now.",
            "If she had studied medicine, she would be a doctor.",
            "If we had moved to London, we would speak better English.",
            "If I had learned to drive, I would have a car now.",
            "If they had saved money, they would own a house."
        ]
    },

    // Exercise and Fitness
    "gym_equipment": {
        title: "Gym Equipment - Equipos de Gimnasio",
        content: [
            "I spent 30 minutes on the treadmill this morning.",
            "She uses dumbbells for strength training.",
            "The stationary bike is great for cardio.",
            "My coach recommends using the stopwatch for intervals.",
            "The weight machines are perfect for beginners."
        ]
    },
    "fitness_activities": {
        title: "Fitness Activities - Actividades de Fitness",
        content: [
            "I prefer cardio exercises over weight lifting.",
            "Bodybuilding requires dedication and consistency.",
            "Running is my favorite form of exercise.",
            "Aerobics classes are fun and energetic.",
            "Circuit training combines strength and cardio."
        ]
    },
    "exercise_movements": {
        title: "Exercise Movements - Movimientos de Ejercicio",
        content: [
            "Do 20 pushups and then 15 squats.",
            "Hold the plank position for 60 seconds.",
            "Burpees are challenging but effective.",
            "Jumping jacks are great for warming up.",
            "Pullups target your upper body muscles."
        ]
    },
    "fitness_terms": {
        title: "Fitness Terms - Términos de Fitness",
        content: [
            "Do 3 sets of 10 reps with proper tempo.",
            "Always warm up before exercising.",
            "Cool-down helps prevent muscle soreness.",
            "High intensity workouts burn more calories.",
            "A personal trainer can help with your diet plan."
        ]
    },
    "weight_goals": {
        title: "Weight & Fitness Goals - Objetivos de Peso y Fitness",
        content: [
            "My goal is weight loss through swimming and jogging.",
            "Regular fitness routines improve health.",
            "Swimming is excellent for full-body fitness.",
            "Jogging helps with cardiovascular health.",
            "Proper sportswear enhances performance."
        ]
    },

    // TV Shows and Entertainment
    "tv_genres": {
        title: "TV Genres - Géneros de TV",
        content: [
            "I love watching documentaries about nature.",
            "Comedy shows always make me laugh.",
            "Drama series can be very emotional.",
            "Reality TV is popular these days.",
            "News programs keep us informed."
        ]
    },
    "movie_types": {
        title: "Movie Types",
        content: [
            "Let's watch an action movie tonight.",
            "I prefer comedy movies to drama.",
            "Horror movies are too scary for me.",
            "Romance movies make me cry.",
            "Sci-fi movies are fascinating."
        ]
    },
    "tv_vocabulary": {
        title: "TV Vocabulary",
        content: [
            "Change the channel with the remote control.",
            "Turn up the volume, please.",
            "This episode is very interesting.",
            "The new season starts next month.",
            "The series finale was disappointing."
        ]
    },
    "entertainment_preferences": {
        title: "Entertainment Preferences",
        content: [
            "I prefer documentaries to reality shows.",
            "I enjoy watching comedies on weekends.",
            "I can't stand horror movies.",
            "My favorite genre is science fiction.",
            "I love binge-watching TV series."
        ]
    },

    // Medical Vocabulary
    "medical_workers": {
        title: "Medical Workers - Trabajadores Médicos",
        content: [
            "The doctor diagnosed my illness.",
            "I need to see a specialist about my back pain.",
            "The nurse took my blood pressure.",
            "My dentist recommended a cleaning.",
            "The paramedic arrived quickly."
        ]
    },
    "body_parts": {
        title: "Body Parts - Partes del Cuerpo",
        content: [
            "My head hurts after the long meeting.",
            "He broke his arm playing football.",
            "She has beautiful eyes.",
            "The baby's chest is rising and falling peacefully.",
            "I twisted my ankle while running."
        ]
    },
    "symptoms": {
        title: "Symptoms - Síntomas",
        content: [
            "I have a terrible headache.",
            "She's been coughing all night.",
            "His fever is getting worse.",
            "I feel nauseous after eating.",
            "My stomach ache started this morning."
        ]
    },
    "ailments": {
        title: "Ailments - Dolencias",
        content: [
            "I caught a cold last week.",
            "The flu kept me in bed for days.",
            "Her allergies act up in spring.",
            "Diabetes requires careful management.",
            "Asthma makes breathing difficult."
        ]
    },
    "injuries": {
        title: "Injuries",
        content: [
            "I scratched my arm on the fence.",
            "She has a bruise on her leg.",
            "He burned his hand on the stove.",
            "My ankle is sprained from running.",
            "The cut on my finger is deep."
        ]
    },
    "medicine": {
        title: "Medicine",
        content: [
            "Take two aspirin for the headache.",
            "This pill should help with the pain.",
            "Use this cough syrup three times a day.",
            "Apply this cream to the rash.",
            "Take your vitamins every morning."
        ]
    },
    "medical_advice": {
        title: "Medical Advice",
        content: [
            "The doctor said to rest in bed.",
            "Drink plenty of fluids today.",
            "Exercise regularly to stay healthy.",
            "Go on a diet to lose weight.",
            "See a specialist about your symptoms."
        ]
    },

    // Perfect Tenses
    "present_perfect_structure": {
        title: "Present Perfect Structure",
        content: [
            "I have lived here for 5 years.",
            "She has eaten sushi before.",
            "We have finished our homework.",
            "They have visited many countries.",
            "He has worked here since 2020."
        ]
    },
    "past_perfect_structure": {
        title: "Past Perfect Structure",
        content: [
            "I had finished my homework before dinner.",
            "She had left before I arrived.",
            "We had seen the movie already.",
            "They had eaten when we called.",
            "He had studied English before moving here."
        ]
    },
    "present_perfect_vs_past": {
        title: "Present Perfect vs Simple Past",
        content: [
            "I have been to Paris (experience).",
            "I went to Paris in 2020 (specific time).",
            "She has lived here for years.",
            "She lived here from 2015 to 2018.",
            "We have finished the project."
        ]
    },
    "perfect_progressive": {
        title: "Perfect Progressive",
        content: [
            "I have been studying English for 3 years.",
            "She has been working here since Monday.",
            "We had been waiting for an hour.",
            "They have been playing soccer all morning.",
            "He had been cooking when I arrived."
        ]
    },
    "perfect_time_expressions": {
        title: "Time Expressions with Perfect",
        content: [
            "I have just finished my work.",
            "She has already left for school.",
            "Have you done your homework yet?",
            "I have never been to Japan.",
            "We have recently moved here."
        ]
    }
};
